import React from 'react';

interface ToothProps {
  isSelected?: boolean;
  className?: string;
  color?: string;
}

// Fallback component for missing teeth
const FallbackTooth: React.FC<ToothProps & { toothNumber: number }> = ({ toothNumber }) => {
  return React.createElement('div', {}, `Tooth ${toothNumber} not found`);
};

// Dynamic imports for all tooth components
const toothComponents: { [key: number]: React.ComponentType<ToothProps> } = {};

// Import all tooth components dynamically
for (let i = 1; i <= 32; i++) {
  const toothNumber = i;
  toothComponents[toothNumber] = React.lazy(() => import(`./${toothNumber}.tsx`));
}

export const getToothComponent = (toothNumber: number): React.ComponentType<ToothProps> => {
  return toothComponents[toothNumber] || (() => React.createElement(FallbackTooth, { toothNumber }));
};

export default toothComponents;
